import React from "react";

import { useTranslations } from "hooks/useTranslations";

/**
 * Mui Components
 */
import { Box, Link, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import {
  travelerInformationSelector,
  ITraveler,
} from "redux/travelerInformation";
import { ISearchForm } from "redux/searchForm";
import { buildSearchObjFromItinerary } from "utils/buildSearchObjFromItinerary";
import { buildQueryString } from "utils/queryStrings";
import { useNavigate } from "react-router-dom";
import { dateTimeStringToDateObj, IItinerary } from "@thekilroygroup/shared-ui";
import { subYears } from "date-fns";
interface IProps {
  itinerary: IItinerary;
}

export const YouthStudentInfo = (props: IProps) => {
  const { itinerary } = props;
  const { translations } = useTranslations();
  const translationsTicketTags = translations.flightCard.ticketTags;
  const { travelers } = useSelector(travelerInformationSelector);
  const navigate = useNavigate();

  const isTooOld = (traveler: ITraveler) => {
    if (!traveler.formFields.dateOfBirth) {
      return false;
    }
    // Check if the traveler is too old for the youth/student ticket
    const lastTravelDateTime =
      dateTimeStringToDateObj(
        itinerary.flights.slice(-1)[0].flightSegments.slice(-1)[0]
          .departureDateTime,
      ) || new Date();

    const maxAge = itinerary?.youthStudentMaxAge || 200;

    return (
      new Date(traveler.formFields.dateOfBirth) <
      subYears(lastTravelDateTime, maxAge)
    );
  };

  const atLeastOneTooOldTraveler = travelers.some((traveler) =>
    isTooOld(traveler),
  );

  const createSearchUrl = () => {
    const searchObj: ISearchForm = buildSearchObjFromItinerary(itinerary);
    return `/search-results?${buildQueryString(searchObj)}`;
  };

  const navigateToSearchResults = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    navigate(createSearchUrl());
  };

  return (
    <Box>
      <Typography variant="bodySmall">
        {translationsTicketTags.maximumAgeDisclaimerText.replace(
          "{years}",
          String(itinerary.youthStudentMaxAge),
        )}
      </Typography>
      {atLeastOneTooOldTraveler && (
        <Typography variant="h6">
          <Link
            onClick={navigateToSearchResults}
            style={{ cursor: "pointer" }}
            href={createSearchUrl()}
            typography={"bodySmall"}
          >
            {translationsTicketTags.seeRelatedFlightsBtn}
          </Link>
        </Typography>
      )}
    </Box>
  );
};
